import { createSelector } from "reselect";
import type { GetLookupInfo, UpdateLookupInfo } from "@costar-search-x/core";
import type { DeepPartialObject } from "@costar-gen/pds-node-client";
import { LocationSearchCriteria as LocationCriteria } from "../../../types";

export const mapCriteriaToProps = createSelector(
  (criteria: LocationCriteria, getLookupInfo?: GetLookupInfo) => ({
    filter: criteria?.locationCriteria?.location?.geography,
    getLookupInfo,
  }),
  ({ filter, getLookupInfo }) => {
    if (filter !== undefined) {
      return {
        selectedSearchTerm: {
          label:
            getLookupInfo?.(filter?.type as number, filter?.id as number)
              ?.name ?? "",
          value: {
            matchType: filter?.type,
            matchId: filter?.id,
          },
        },
      };
    }
  }
);

export const mapUpdateCriteriaToProps = createSelector(
  (
    updateCriteria: (criteria: DeepPartialObject<LocationCriteria>) => void,
    updateLookupInfo?: UpdateLookupInfo
  ) => ({
    updateCriteria,
    updateLookupInfo,
  }),
  ({ updateCriteria, updateLookupInfo }) => ({
    onChange: ({
      newValue,
    }: {
      newValue: {
        label: string;
        value: { MatchType: number; MatchId: number };
      };
    }) => {
      if (newValue) {
        const { label, value } = newValue || {};
        updateLookupInfo?.(value?.MatchType, value?.MatchId, { name: label });
        updateCriteria({
          locationCriteria: {
            location: {
              geography: {
                id: value.MatchId,
                type: value.MatchType,
              },
            },
          },
        });
      } else {
        updateCriteria({
          locationCriteria: {
            location: {
              geography: undefined,
            },
          },
        });
      }
    },
  })
);
